module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/hipercard-nobg.svg?a4ba73a87832af37fa15b7e3e94c8859";